/**
 * testSuites.service.ts — Layer 3: Test Suites (internal QA dashboard) Domain
 */

import { getRequest, postRequest } from './http.service';
import {
  URL_TEST_SUITES_LATEST_PER_PATTERN,
  URL_TEST_SUITES_COLLECT,
  URL_TEST_SUITES_RUNS,
  URL_TEST_SUITE_RUN_BY_ID,
  URL_TEST_SUITES_RUN_SUITE,
  URL_TEST_SUITES_RUN_ALL,
  URL_TEST_SUITES_CANCEL_RUN,
} from './url.service';

/** Get the latest completed run per test pattern */
export const fetchLatestPerPattern = () =>
  getRequest(URL_TEST_SUITES_LATEST_PER_PATTERN);

/** Collect all discovered test names/files */
export const fetchCollectedTests = () =>
  getRequest(URL_TEST_SUITES_COLLECT);

/** Get a page of past runs */
export const fetchTestRuns = (page: number, limit: number) =>
  getRequest(URL_TEST_SUITES_RUNS(page, limit));

/** Get the full detail of a single run */
export const fetchTestRunById = (runId: string) =>
  getRequest(URL_TEST_SUITE_RUN_BY_ID(runId));

/** Start a run for a single suite pattern */
export const runTestSuite = (pattern: string) =>
  postRequest(URL_TEST_SUITES_RUN_SUITE, { pattern });

/** Start a run of every suite */
export const runAllTestSuites = () =>
  postRequest(URL_TEST_SUITES_RUN_ALL, {});

/** Cancel an in-progress run */
export const cancelTestRun = (runId: string) =>
  postRequest(URL_TEST_SUITES_CANCEL_RUN(runId), {});
